// extracted by mini-css-extract-plugin
module.exports = {"title":"ReceiptItemStyles_title__2XXww","content":"ReceiptItemStyles_content__2K75H","buttons":"ReceiptItemStyles_buttons__1mDRo","padding":"ReceiptItemStyles_padding__e25PQ"};